// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var Js_dict = require("bs-platform/lib/js/js_dict.js");
var Belt_Array = require("bs-platform/lib/js/belt_Array.js");
var Belt_Option = require("bs-platform/lib/js/belt_Option.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var Belt_MapString = require("bs-platform/lib/js/belt_MapString.js");

function mapKeys(xs, fn) {
  return Belt_MapString.fromArray(Belt_Array.map(Belt_MapString.toArray(xs), (function (param) {
                    return /* tuple */[
                            Curry._1(fn, param[0]),
                            param[1]
                          ];
                  })));
}

function keepMapWithKey(xs, fn) {
  return Belt_MapString.fromArray(Belt_Array.keepMap(Belt_MapString.toArray(xs), (function (param) {
                    var k = param[0];
                    return Belt_Option.map(Curry._2(fn, k, param[1]), (function (v2) {
                                  return /* tuple */[
                                          k,
                                          v2
                                        ];
                                }));
                  })));
}

function keepMap(xs, fn) {
  return keepMapWithKey(xs, (function (param, v) {
                return Curry._1(fn, v);
              }));
}

function innerJoin(xs, ys) {
  return keepMapWithKey(xs, (function (param, v) {
                return Belt_MapString.get(ys, v);
              }));
}

function mergeOverride(xs, ys) {
  return Belt_MapString.merge(xs, ys, (function (_key, ox, oy) {
                if (oy !== undefined) {
                  return Caml_option.some(Caml_option.valFromOption(oy));
                } else {
                  return ox;
                }
              }));
}

function fromDict(d) {
  return Belt_MapString.fromArray(Js_dict.entries(d));
}

function toDict(m) {
  return Js_dict.fromArray(Belt_MapString.toArray(m));
}

exports.keepMap = keepMap;
exports.keepMapWithKey = keepMapWithKey;
exports.mapKeys = mapKeys;
exports.innerJoin = innerJoin;
exports.mergeOverride = mergeOverride;
exports.fromDict = fromDict;
exports.toDict = toDict;
/* No side effect */



//////////////////
// WEBPACK FOOTER
// ../belt-holes/src/BeltHoles_Map_String.bs.js
// module id = 357
// module chunks = 0